module.exports = __webpack_public_path__ + "officialStatic/img/logo.a484ebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo.png
// module id = 7PyK
// module chunks = 0